import React from "react";
import { useTranslation } from "react-i18next";

export default function PastTripCatchMediaLocationSection({ pastTripCatch }) {
  const { t } = useTranslation();
  const {
    formState,
    minDate,
    maxDate,
    mediaFile,
    mediaMetadataMessage,
    coordinateError,
    handleFieldChange,
    handleCoordinatesBlur,
    handlePickCoordinatesFromMap,
    handleMediaChange,
  } = pastTripCatch;

  return (
    <>
      <label className="mytrips-trip-catch-field">
        <span className="mytrips-trip-catch-label">
          {t("date", { defaultValue: "Date" })} *
        </span>
        <input
          type="date"
          className="mytrips-trip-catch-input"
          value={formState.date}
          onChange={handleFieldChange("date")}
          min={minDate || undefined}
          max={maxDate || undefined}
          required
        />
      </label>

      <label className="mytrips-trip-catch-field">
        <span className="mytrips-trip-catch-label">
          {t("time", { defaultValue: "Time" })}
        </span>
        <input
          type="time"
          className="mytrips-trip-catch-input"
          value={formState.time}
          onChange={handleFieldChange("time")}
        />
      </label>

      <label className="mytrips-trip-catch-field">
        <span className="mytrips-trip-catch-label">
          {t("coordinates", { defaultValue: "Coordinates" })}
        </span>
        <input
          type="text"
          className="mytrips-trip-catch-input"
          value={formState.coordinates}
          onChange={handleFieldChange("coordinates")}
          onBlur={handleCoordinatesBlur}
          placeholder={t("catch_coordinates_placeholder", {
            defaultValue: "e.g., 42.12345, 27.12345",
          })}
          aria-invalid={coordinateError ? "true" : undefined}
          aria-describedby={
            coordinateError ? "past-trip-catch-coordinates-error" : undefined
          }
        />
        {coordinateError ? (
          <span
            id="past-trip-catch-coordinates-error"
            className="mytrips-trip-catch-error-text"
          >
            {t(coordinateError)}
          </span>
        ) : null}
        <button
          type="button"
          className="mytrips-trip-catch-map-select"
          onClick={handlePickCoordinatesFromMap}
        >
          {t("trip_add_catch_select_from_map")}
        </button>
      </label>

      <label className="mytrips-trip-catch-field">
        <span className="mytrips-trip-catch-label">
          {t("location", { defaultValue: "Location" })}
        </span>
        <input
          type="text"
          className="mytrips-trip-catch-input"
          value={formState.location}
          onChange={handleFieldChange("location")}
          placeholder={t("trip_location_placeholder", {
            defaultValue: "Trip location",
          })}
        />
      </label>

      <label className="mytrips-trip-catch-field mytrips-trip-catch-field--full">
        <span className="mytrips-trip-catch-label">
          {t("trip_add_catch_upload_image", {
            defaultValue: "Upload Image (optional)",
          })}
        </span>
        <input
          type="file"
          accept="image/*"
          className="mytrips-trip-catch-file"
          onChange={handleMediaChange}
        />
        {mediaFile ? (
          <div className="mytrips-trip-catch-file-meta">
            <span className="mytrips-trip-catch-file-name">{mediaFile.name}</span>
            {mediaMetadataMessage ? (
              <span className="mytrips-trip-catch-file-name">
                {mediaMetadataMessage}
              </span>
            ) : null}
          </div>
        ) : null}
      </label>
    </>
  );
}
